import type { BaseQueryFn, FetchArgs, FetchBaseQueryError, FetchBaseQueryMeta } from '@reduxjs/toolkit/query/react';
import { fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import LocalCache from 'src/common/LocalCache';

/** Base query with Authorization header and 401 redirect handling. */
export const baseQueryWithAuth: BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError> = async (
  args,
  api,
  extraOptions,
) => {
  const result = await fetchBaseQuery({
    prepareHeaders: (headers) => {
      const token = LocalCache.fetchToken();
      headers.set('Authorization', `Bearer ${token}`);
      return headers;
    },
  })(args, api, extraOptions);
  if (result.error && result.error.status === 401) {
    if (!window.location.pathname.includes('/auth'))
      window?.location.replace(`/auth/login?redirect=${window.location.pathname}`);
  }
  return result;
};

/** Extracts the `data` property from API responses using `data.data` syntax. */
function transformResponse<T>(baseQueryReturnValue: { data: T }, _meta?: FetchBaseQueryMeta): T {
  return baseQueryReturnValue?.data;
}
/** Extracts error messages from API responses using `data.message` or `data.error` syntax. */
function transformErrorResponse(baseQueryReturnValue: FetchBaseQueryError, _meta?: FetchBaseQueryMeta) {
  if ('message' in baseQueryReturnValue && baseQueryReturnValue.message) return baseQueryReturnValue.message;
  else if ('error' in baseQueryReturnValue && baseQueryReturnValue.error) return baseQueryReturnValue.error;
  else return baseQueryReturnValue.data;
}
/** Object containing response and error transformers for API responses. */
export const transformResponses = { transformResponse, transformErrorResponse };
